import "./Home.module.css";
import Encabezado from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TePassaEsto from "./sections/TePassaEsto";
import ComoFuncionaElCoaching from "./sections/ComoFuncionaElCoaching";
import SobreGuillermoBogao from "./sections/SobreGuillermoBogao";
import LlamadaALaAccionFinal from "./sections/LlamadaALaAccionFinal";
import PieDePA_gina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Encabezado />
      <Hero />
      <TePassaEsto />
      <ComoFuncionaElCoaching />
      <SobreGuillermoBogao />
      <LlamadaALaAccionFinal />
      <PieDePA_gina />
    </div>;
}